import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StyledButton } from "@insite/mobius/Clickable";
import { FormFieldStyle } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface ProductDetailsViewStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    rightColumnInnerContainer?: GridContainerProps;
    topColumnInnerContainer?: GridContainerProps;
    bottomColumnInnerContainer?: GridContainerProps;
    topGridItem?: GridItemProps;
    topColumnGridItem?: GridItemProps;
    bottomColumnInnerGridItem?: GridItemProps;
    bottomGridItem?: GridItemProps;
    rightSecondColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: InjectableCss;
    rightColumnGridItem?: GridItemProps;
    rightSecondColumnItemTop?: InjectableCss;
    rightSecondColumnItemBottom?: InjectableCss;
}

export const viewStyles: ProductDetailsViewStyles = {
    leftColumnGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px;
                        border-bottom: 1px solid ${getColor("common.border")};
                    `,
                    css`
                        padding: 0px;
                        border-bottom: 1px solid ${getColor("common.border")};
                    `,
                    null,
                    null,
                    css`
                        flex-basis: 39%;
                        max-width: 39%;
                        padding: 0px;
                    `,
                ])}
            > div[class^="Wrapper"] {
                ${GridWrapper}:first-child {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                        ])}
                }
                > div[class^="sc"]:first-child {
                    min-height: 300px !important;
                    border-top: none;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            null,
                            null,
                            css`
                                position: sticky;
                                top: 6em;
                                margin-bottom: 5.5rem;
                            `,
                        ])}
                    > img {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                null,
                                null,
                                css`
                                    width: 100%;
                                `,
                            ])}
                    }
                }
                > div {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            null,
                            null,
                            // css`
                            //     position: relative;
                            //     top: 90px;
                            // `,
                        ])}
                }
                ${GridWrapper}:nth-child(2) {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                        ])}
                }
                > div[class^="sc"] {
                    border: none;
                    padding: 0px;
                }
            }
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 7, 7],
        css: css`
            flex-direction: column;
            padding: 15px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        border-top: 1px solid #c5c5c7;
                    `,
                    css`
                        border-top: 1px solid #c5c5c7;
                    `,
                    null,
                    null,
                    css`
                        flex-basis: 61%;
                        max-width: 61%;
                    `,
                ])}
        `,
    },
    topColumnInnerContainer: {
        css: css`
            flex-grow: unset;
            flex-basis: unset;
            display: block;
        `,
    },
    bottomColumnInnerContainer: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
        `,
    },
    topColumnGridItem: {
        width: 12,
        css: css`
            padding: 0px;
            > div[class^="Wrapper"] {
                padding: 0px 15px;
            }
        `,
    },
    bottomColumnInnerGridItem: {
        width: 12,
        css: css`
            padding: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    leftColumnInnerContainer: {
        css: css`
            div[data-test-selector="productAvailabilityWrapper"]{
                margin-bottom: 15px;
                strong{
                font-weight: 500;
                }

                div{
                    padding:0px !important;
                    margin: 0px;
                    margin-bottom: 3px;
                    span[data-test-selector="availabilityMessage"]{
                    display:flex;
                    align-items: center;
                    font-family: "Roboto-bold";
                    font-size: 15px;
                    font-weight: 700;
                    margin-bottom: 8px;
                    gap: 5px;
                    svg{
                        width: 20px;
                        height: 20px;
                        margin: 0px;
                        color: #92BF41;
                    }
                       >span{
                        line-height: normal;
                        font-size: 15px;
                        }
                    }
                }
            }
            flex-basis: 65%;
            max-width: 65%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                        margin-top: 1rem;
                        flex-basis: 100%;
                        max-width: 100%;
                        border-bottom: 1px solid #c5c5c7;
                        border-top: 1px solid #c5c5c7;
                    `,
                    css`
                        order: 2;
                        margin-top: 1rem;
                        flex-basis: 100%;
                        max-width: 100%;
                        border-bottom: 1px solid #c5c5c7;
                        border-top: 1px solid #c5c5c7;
                    `,
                    css`
                        flex-basis: 60%;
                        max-width: 60%;
                    `,
                    css`
                        flex-basis: 50%;
                        max-width: 50%;
                    `,
                    null,
                ])}
        `,
    },
    rightColumnInnerContainer: {
        css: css`
            flex-basis: 35%;
            max-width: 35%;
            po
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        order: 1;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        order: 1;
                    `,
                    css`
                        flex-basis: 40%;
                        max-width: 40%;
                    `,
                    css`
                        flex-basis: 50%;
                        max-width: 50%;
                    `,
                    null,
                ])}
        `,
    },
    topGridItem: { width: 12 },
    bottomGridItem: {
        width: 12,
        css: css`
            padding: 0px 15px 10px;
            > div[class^="Wrapper"] {
                > ${GridWrapper} {
                    &:nth-child(1) {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    display: none;
                                `,
                                css`
                                    display: none;
                                `,
                                null,
                                null,
                                null,
                            ])}
                    }
                    &:nth-child(2) {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    display: none;
                                    margin-bottom: 10px;
                                `,
                                css`
                                    display: none;
                                    margin-bottom: 10px;
                                `,
                                null,
                                null,
                                null,
                            ])}
                    }
                }
                > div[class^="sc"] {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                border-top: 0px;
                            `,
                            css`
                                border-top: 0px;
                            `,
                            null,
                            null,
                            null,
                        ])}
                    section {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    display: none;
                                `,
                                css`
                                    display: none;
                                `,
                                null,
                                null,
                                null,
                            ])}
                    }
                }
                ${StyledButton} {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
                > div[class^="sc"]:last-child {
                    > div[class^="Wrapper"] {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    display: block;
                                `,
                                css`
                                    display: block;
                                `,
                                css`
                                    display: none;
                                `,
                                css`
                                    display: none;
                                `,
                                css`
                                    display: none;
                                `,
                            ])}
                        > ${GridWrapper} {
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                        margin-bottom: 0px;
                                    `,
                                    css`
                                        margin-bottom: 0px;
                                    `,
                                    null,
                                    null,
                                    null,
                                ])}
                            >${GridOffset} {
                                > ${GridItemStyle} {
                                    ${TypographyStyle}:first-child {
                                        font-size: 16px;
                                        font-family: "Roboto-Bold";
                                        margin-bottom: 5px;
                                    }
                                    ${TypographyStyle}:last-child {
                                        font-size: 16px;
                                        font-family: "Roboto-Regular";
                                    }
                                }
                            }
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px;
                        margin-top: 1rem !important;
                    `,
                    css`
                        padding: 0px;
                        margin-top: 1rem !important;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    rightSecondColumnGridItem: {
        width: 12,
        css: css`
            max-width: 100% !important;
            border: 1px solid #D3D3D3;
            border-radius: 5px;
            box-sizing: border-box;
            max-width: 305px;
            padding: 0;
            height: 100%;
           
            background:#ffffff;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        border: none !important;
                        box-shadow: none !important;
                    `,
                    css`
                        border: none !important;
                        box-shadow: none !important;
                    `,
                    null,
                    null,
                    null,
                ])}
            > div[class^="Wrapper"] {
                section {
                    color: ${getColor("text.accent")};
                    font-family: "Roboto-Bold";
                    font-size: 24px;
                    line-height: 33px;
                    // padding: 20px 15px 0px 15px;
                    > div {
                        > div {
                            ${TypographyStyle} {
                                font-size: 26px;
                                color: ${getColor("text.accent")} ;
                            }
                        }
                    }
                    > div :last-child {
                        display: none;
                    }
                }
                > div[class^="FormFieldStyle"] {
                    padding: 0px 15px 15px 15px;
                    margin: 0px;
                    ${TypographyStyle} {
                        color: ${getColor("text.accent")};
                    }
                }
                > div:nth-child(2) {
                    > ${GridOffset} {
                        > ${GridItemStyle}:first-child {
                            flex-basis: 100%;
                            max-width: 100%;
                            > div[class^="InventoryMessage"] {
                                width: 100%;
                                border-bottom: 1px solid ${getColor("common.border")};
                                padding-bottom: 10px;
                                > span {
                                    margin: 2px 0;
                                    // > ${IconWrapper} {
                                    //     > svg {
                                    //         stroke-width: 4;
                                    //     }
                                    // }
                                    // > span {
                                    //     color: #158b0b;
                                    //     font-weight: 800;
                                    // }
                                }
                            }
                        }
                        > ${GridItemStyle}:last-child {
                            padding: 6px 15px 0px;
                        }
                    }
                }
            }
        `,
    },
    rightColumnGridItemHidden: {
        // below: "md",
        css: css``,
    },
    container: {
        css: css`
            margin-bottom: 2rem;
            ${GridOffset} {
                max-width: 100%;
                margin: 0px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        border-bottom: 1px solid ${getColor("common.border")};
                    `,
                    css`
                        border-bottom: 1px solid ${getColor("common.border")};
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    rightSecondColumnItemTop:{
        css: css`
        margin-bottom: 15px;
        width: 100%;
        `
    }, 
    rightSecondColumnItemBottom:{
        css: css`
        margin-top:15px;
        width: 100%;
        `
    }

};

const styles = viewStyles;

const ProductDetailsView: React.FC<WidgetProps> = props => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.leftColumnGridItem} data-test-selector="productDetails_leftColumn">
                <Zone contentId={props.id} zoneName="Content5" />
            </GridItem>
            <GridItem {...styles.rightColumnGridItem} data-test-selector="productDetails_rightColumn">
                <GridContainer
                    {...styles.topColumnInnerContainer}
                    data-test-selector="productDetails_descriptionColumn"
                >
                    <GridItem
                        {...styles.topColumnGridItem}
                        data-test-selector="productDetails_descriptionColumnGridItem"
                    >
                        <Zone contentId={props.id} zoneName="Content4" {...styles.rightColumnGridItemHidden} />
                    </GridItem>
                    {/* <GridItem {...styles.topGridItem} data-test-selector="productDetails_topGridItem">
                        <Zone contentId={props.id} zoneName="Content0" />
                    </GridItem> */}
                </GridContainer>
                <GridContainer {...styles.bottomColumnInnerContainer}>
                    <GridItem {...styles.bottomColumnInnerGridItem} data-test-selector="productDetails_bottomGridItem">
                        <GridContainer
                            {...styles.leftColumnInnerContainer}
                            data-test-selector="productDetails_firstRightColumn"
                        >
                            <GridItem
                                {...styles.bottomGridItem}
                                data-test-selector="productDetails_bottomInnerGridItem"
                            >
                                <Zone contentId={props.id} zoneName="Content2" />
                            </GridItem>
                        </GridContainer>
                        <GridContainer
                            {...styles.rightColumnInnerContainer}
                            data-test-selector="productDetails_secondRightColumn"
                        >
                            <StyledWrapper {...styles.rightSecondColumnItemTop}>
                                <Zone contentId={props.id} zoneName="Content6" {...styles.rightColumnGridItemHidden} />
                            </StyledWrapper>
                            <GridItem
                                {...styles.rightSecondColumnGridItem}
                                data-test-selector="productDetails_rightQuantityColumn"
                            >
                                <Zone contentId={props.id} zoneName="Content3" {...styles.rightColumnGridItemHidden} />
                            </GridItem>
                            <StyledWrapper {...styles.rightSecondColumnItemBottom}>
                                <Zone contentId={props.id} zoneName="Content7" {...styles.rightColumnGridItemHidden} />
                            </StyledWrapper>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
